var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "line-gauge-container" }, [
    _c(
      "div",
      {
        staticClass:
          "lg-col lg-label typography--body-3 typography--color-secondary"
      },
      [_vm._v("\n    " + _vm._s(_vm.label) + "\n  ")]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "lg-col lg-box" },
      [
        _c("LineGauge", {
          attrs: { value: _vm.ratio, "bg-color": _vm.bgColor }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "lg-col lg-position-num typography--body-3 typography--color-secondary"
      },
      [_vm._v("\n    " + _vm._s(_vm.value || "-") + _vm._s(_vm.unit) + "\n  ")]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-737ef387", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-737ef387","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BasicLineGauge.vue
// module id = vfyc
// module chunks = 1